import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Subscribe } from 'unstated';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import _ from 'lodash';

import removePrivateProps from '../../utils/removePrivateProps';
import AuthContainer from './AuthContainer';

class Auth extends React.Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    showLoader: PropTypes.bool,
    authState: PropTypes.object.isRequired,
  };

  static defaultProps = {
    showLoader: false,
  };

  state = {
    value: 0,
    valueBuffer: 0,
    fadeOut: false,
    loaderHidden: false,
  };

  componentDidUpdate(prevProps) {
    const { authState, showLoader } = this.props;
    if (showLoader && !_.isEqual(prevProps.authState, authState)) {
      const { authVerified, userAuthenticated, authenticatedUserInfo } = authState;
      let value;
      let valueBuffer;
      if (!authVerified) {
        value = 70;
        valueBuffer = 80;
      } else if (userAuthenticated) {
        if (!authenticatedUserInfo) {
          value = 80;
          valueBuffer = 90;
        } else {
          value = 100;
          valueBuffer = 100;
        }
      } else {
        value = 100;
        valueBuffer = 100;
      }

      if (value === 100) {
        // Hide the loader after 1000ms after the value is completed to 100
        setTimeout(() => {
          this.setState({ fadeOut: true }, () => {
            // Remove the loader and render the children once the loader
            // is faded out
            setTimeout(() => {
              this.setState({ loaderHidden: true });
            }, 1000);
          });
        }, 1000);
      }

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ value, valueBuffer });
    }
  }

  _renderChildren = () => {
    const { children, authState, ...restProps } = this.props;
    return children({
      authState,
      ...restProps,
    });
  };

  _renderChildrenWithLoader = () => {
    const {
      value, valueBuffer, fadeOut, loaderHidden,
    } = this.state;

    if (!loaderHidden) {
      return (
        <Container fadeOut={fadeOut}>
          <ProgressContainer>
            <LinearProgress variant="buffer" value={value} valueBuffer={valueBuffer} />
          </ProgressContainer>
          <Typography variant="body2">Authenticating...</Typography>
        </Container>
      );
    }

    return this._renderChildren();
  };

  render() {
    const { showLoader } = this.props;
    if (showLoader) {
      return this._renderChildrenWithLoader();
    }

    return this._renderChildren();
  }
}

export default props => (
  <Subscribe to={[AuthContainer]}>
    {(auth) => {
      // destructuring auth container states
      // dont' pass the setState directly to the Auth component as we want
      // authentication services to change the auth states
      const { state: authState, setState, ...authProps } = auth;

      return <Auth authState={authState} {...props} {...removePrivateProps(authProps)} />;
    }}
  </Subscribe>
);

const Container = styled.div`
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: ${styleProps => (styleProps.fadeOut ? 0 : 1)};
  transition: 1.2s ease-in-out; /* slightly offsetting the transition timeout */

  & > * + * {
    margin-top: 10px !important;
  }
`;

const ProgressContainer = styled.div`
  width: 400px;
`;



// WEBPACK FOOTER //
// ./src/components/Auth/Auth.js